













































import { Component, Vue, Model, Emit } from "vue-property-decorator";
import { VibrixEventMailTemplate } from "@/interfaces/vibrixEvent";

@Component
export default class EventMailTemplateEditor extends Vue {
    @Model() public model!: VibrixEventMailTemplate;

    @Emit() public editorClose() {
        return;
    }

    public get templates() {
        return this.model;
    }

    public set templates(value: VibrixEventMailTemplate) {
        this.$emit("model", value);
    }
}
